import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inferConsentText'
})
export class InferConsentTextPipe implements PipeTransform {

  transform(consentName: string): any {
    return `ENTITY.CONSENTS.${consentName.toUpperCase()}`;
  }
}
